import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { NSUTMetricsConstants } from '@ruby/configs/unit-train-metrics.constants';
import { NSUnitTrainConstants } from '@ruby/configs/unit-train.constants';
import { IUTDetention, IUTDetentionDispute } from '@ruby/modules/unit-train/models/unit-train-metrics.interface';
import { IUnitTrainFilters, IUTFiltersConfigurations } from '@ruby/modules/unit-train/models/unit-train.interface';
import { fromUTAdvanceSearch, UTAdvanceSearchActions, UTAdvanceSearchSelectors } from '@ruby/modules/unit-train/store/ut-advance-search.index';
import { EUTMetricType } from '@ruby/shared/enums/unit-train.enums';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-ut-results-detentions-container',
  templateUrl: './ut-results-detentions.container.html',
  styleUrls: ['./ut-results-detentions.container.scss']
})
export class UTResultsDetentionsContainer implements OnDestroy {
  gridConfigs!: IGridConfigurations;
  filtersConfigs!: Partial<IUTFiltersConfigurations>;
  type!: EUTMetricType;
  store$: Observable<fromUTAdvanceSearch.State>;
  data: Array<IUTDetentionDispute | IUTDetention> = [];

  constructor(private store: Store<fromUTAdvanceSearch.State>) {
    this.store$ = store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchMetricsType).pipe(
      tap((state: { type: EUTMetricType }) => {
        this.type = state.type;
        this.gridConfigs = NSUTMetricsConstants.utMetricsGridConfigs[state.type];
        this.filtersConfigs = NSUnitTrainConstants.utMetricsFiltersConfigs[this.type];
      }),
      switchMap(() => this.store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchState)),
      tap(this.setupDataByType.bind(this))
    );
  }

  ngOnDestroy(): void {
    this.store.dispatch(UTAdvanceSearchActions.resetAdvanceSearchState());
  }

  /**
   * Make Advance Search
   *
   * @summary emit an event to make a search
   * @param $filters: IUnitTrainFilters
   * @return void
   */
  makeAdvanceSearch($filters: IUnitTrainFilters): void {
    switch (this.type) {
      case EUTMetricType.REVIEW_DISPUTES:
        this.store.dispatch(UTAdvanceSearchActions.getReviewDisputes({ data: $filters }));
        break;
      case EUTMetricType.REVIEW_DETENTION:
        this.store.dispatch(UTAdvanceSearchActions.getDetentionHistory({ data: $filters }));
        break;
    }
  }

  /**
   * Setup Data By Type
   *
   * @summary Set data value base on grid type
   * @param state: fromUTAdvanceSearch.State
   * @return void
   */
  setupDataByType(state: fromUTAdvanceSearch.State): void {
    switch (this.type) {
      case EUTMetricType.REVIEW_DISPUTES:
        this.data = state.disputes;
        break;
      case EUTMetricType.REVIEW_DETENTION:
        this.data = state.detentions;
        break;
      default:
        this.data = [];
    }
  }
}
